// REACT, STYLE, STORIES & COMPONENT
import React, { useEffect, useState } from 'react';
import styles from './CandidateExternalProfile.module.scss';

// ASSETS

// 3RD PARTY
import classNames from 'classnames';

// OTHER COMPONENTS
import { CandidateExternalSummary } from '../CandidateExternalSummary';
import { CandidateExternalRoleFit } from '../CandidateExternalRoleFit';
import { UserAssessmentsResults } from '../UserAssessmentsResults';

// UTILS
import * as api from 'api';
import { useTranslate } from 'utils/translator';
import { getMappedCandidate } from 'utils/users';

const PAGES = [
  { value: 'summary', label: 'candidate_summary' },
  { value: 'assessments', label: 'candidate_assessments' },
  { value: 'rolefit', label: 'candidate_rolefit' },
];


// COMPONENT: CandidateProfile
const CandidateExternalProfile = (props) => {
  // PROPS
  const { id, results } = props;

  // SPECIAL HOOKS
  const translate = useTranslate();

  const [ currentPage, setCurrentPage ] = useState(PAGES[0].value);

  // CANDIDATE: STATE, EFFECTS, STORE, METHODS, EVENT HANDLES, HELPERS, RENDERS
  const [ candidate, setCandidate ] = useState();
  useEffect(() => {
    api.get(`recruiting/candidates/${id}`, { expand: 'jobs' })
    .then(({ ok, status, data }) => {
      if (ok && status === 200) {
        setCandidate(getMappedCandidate(data));
      }
    });
  }, [ translate, id ]);

  const renderPage = () => {
    switch (currentPage) {
      case 'summary':
        return (
          <CandidateExternalSummary
            setCurrentPage={setCurrentPage}
            candidate={candidate}
          />
        );
      case 'assessments':
        return (
          <UserAssessmentsResults
            user={candidate}
            isCandidate={candidate?.profileData}
            results={results}
          />
        );
      case 'rolefit':
        return (
          <CandidateExternalRoleFit
            candidate={candidate}
            results={results}
          />
        );
      default:
    }
    return null;
  };

  if (!candidate) {
    return null;
  }


  // RENDER: CandidateProfile
  return (
    <div className={classNames(styles.candidateExternalProfile)}>
      { /* NAVIGATION */ }
      <div className={styles.navigation}>
        { PAGES
        .filter((page) => !(page.value === 'rolefit'
            && (
              !candidate.jobs || candidate.jobs.length === 0
              || !candidate.jobs.find((job) => job.incomplete === false)
            )))
        .map((page) => (
          <div
            key={page.value}
            role='presentation'
            className={classNames(styles.item, { [styles.active]: currentPage === page.value })}
            onClick={() => setCurrentPage(page.value)}
          >
            { translate(page.label) }
          </div>
        )) }
      </div>

      { renderPage() }
    </div>
  );
};

export default CandidateExternalProfile;
